function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#eaeaf3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#babed1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399b5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  y2: 0,
  xlinkHref: "#linear-gradient-2"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "vehicle_performance",
  transform: "translate(-5 -5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6963",
  "data-name": "Ellipse 6963",
  cx: 75,
  cy: 75,
  r: 75,
  transform: "translate(5 5)",
  fill: "#eaeaf3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_34823",
  "data-name": "Group 34823",
  transform: "translate(42.119 30)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_34820",
  "data-name": "Group 34820"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63023",
  "data-name": "Path 63023",
  d: "M6.11,0H69.652a6.11,6.11,0,0,1,6.11,6.11V94.092a6.11,6.11,0,0,1-6.11,6.11H6.11A6.11,6.11,0,0,1,0,94.092V6.11A6.11,6.11,0,0,1,6.11,0Z",
  transform: "translate(75.762 100.202) rotate(180)",
  fill: "url(#linear-gradient)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_34821",
  "data-name": "Group 34821",
  transform: "translate(4.686 4.686)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63024",
  "data-name": "Path 63024",
  d: "M112.993,125.515H47.007a.2.2,0,0,1-.2-.2V34.888a.2.2,0,0,1,.2-.2h65.986a.2.2,0,0,1,.2.2v90.425A.2.2,0,0,1,112.993,125.515Zm-65.784-.4h65.582V35.09H47.209Z",
  transform: "translate(-46.805 -34.686)",
  fill: "#eaeaf3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_34822",
  "data-name": "Group 34822",
  transform: "translate(9.621 10.998)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18059",
  "data-name": "Rectangle 18059",
  width: 18.329,
  height: 2.444,
  transform: "translate(36.659)",
  fill: "#969bb7"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18060",
  "data-name": "Rectangle 18060",
  width: 18.329,
  height: 2.444,
  transform: "translate(36.659 4.888)",
  fill: "#b6bacc"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18061",
  "data-name": "Rectangle 18061",
  width: 18.329,
  height: 2.444,
  transform: "translate(36.659 9.775)",
  fill: "#d1d5e0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18062",
  "data-name": "Rectangle 18062",
  width: 54.988,
  height: 2.444,
  transform: "translate(0 18.329)",
  fill: "#eaeaf3"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18063",
  "data-name": "Rectangle 18063",
  width: 54.988,
  height: 2.444,
  transform: "translate(0 25.661)",
  fill: "#eaeaf3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_34824",
  "data-name": "Group 34824",
  transform: "translate(59.111 75.61)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18064",
  "data-name": "Rectangle 18064",
  width: 8.048,
  height: 22.654,
  transform: "translate(0 11.086)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18065",
  "data-name": "Rectangle 18065",
  width: 8.048,
  height: 19.665,
  transform: "translate(11.243 14.075)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18066",
  "data-name": "Rectangle 18066",
  width: 8.048,
  height: 30.045,
  transform: "translate(22.487 3.696)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63025",
  "data-name": "Path 63025",
  d: "M100.889,109.35H92.841V75.7a.087.087,0,0,1,.088-.088H100.8a.087.087,0,0,1,.088.088Z",
  transform: "translate(-59.111 -75.61)",
  fill: "url(#linear-gradient-2)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18067",
  "data-name": "Rectangle 18067",
  width: 54.988,
  height: 2.444,
  transform: "translate(52.506 109.35)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18068",
  "data-name": "Rectangle 18068",
  width: 54.988,
  height: 2.444,
  transform: "translate(52.506 116.682)",
  fill: "#b9bdd0"
}));

var SvgEmptyVehiclePerformance = function SvgEmptyVehiclePerformance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyVehiclePerformance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-vehicle-performance.d933f288.svg";
export { ForwardRef as ReactComponent };